export const finishLoadingAfter = (
  startedAt: number,
  finish: () => void,
  minimumDuration = 0,
): ReturnType<typeof setTimeout> => {
  const remaining = Math.max(0, minimumDuration - (Date.now() - startedAt));
  return setTimeout(finish, remaining);
};
